import ModalFooter from "@lib/common/components/modals/ModalFooter";
import { getExperimentMeasurementsFromMapping } from "@lib/dataset/Mapping/getExperimentMeasurementsFromMapping";
import getExperimentParametersFromMapping from "@lib/dataset/Mapping/getExperimentParametersFromMapping";
import type { ColumnMapping } from "@lib/dataset/Mapping/types";
import { hasBlockingUploadMappingItems } from "@lib/dataset/Mapping/uploadMappingValidation";
import { Badge, Box, Button, Divider, Group, Stack, Switch, Text, TextInput } from "@mantine/core";
import { useField } from "@mantine/form";
import { useState } from "react";

export default function SummaryView({
  items,
  onComplete,
  onBack
}: {
  items: ColumnMapping[];
  onComplete: (options: { createExperiment?: boolean; datasetName: string }) => void;
  onBack: () => void;
}) {
  const datasetField = useField({
    initialValue: ""
  });

  const [createExperiment, setCreateExperiment] = useState(true);
  const onCompleteClick = () => {
    onComplete({ createExperiment: createExperiment, datasetName: datasetField.getValue() });
  };

  const parameters = getExperimentParametersFromMapping(items);
  const measurements = getExperimentMeasurementsFromMapping(items);

  return (
    <Box>
      <Stack p="lg" gap="xl">
        <Stack gap="sm">
          <Group align="center">
            <Text miw={100}>Name: </Text>
            <TextInput {...datasetField.getInputProps()} placeholder="Dataset Name" />
          </Group>
          <Group align="center">
            <Text miw={100}>Variables: </Text>
            <Badge color="gray" variant="outline">
              {parameters.length}
            </Badge>
          </Group>
          <Group align="center">
            <Text miw={100}>Results: </Text>
            <Badge color="gray" variant="outline">
              {measurements.length}
            </Badge>
          </Group>
        </Stack>
        <Switch
          label="Create experiment from dataset"
          checked={createExperiment}
          onChange={() => setCreateExperiment(!createExperiment)}
        />
      </Stack>

      <Divider />
      <ModalFooter>
        <Button color="gray" variant="light" onClick={onBack}>
          Back
        </Button>
        <Button variant="filled" onClick={onCompleteClick} disabled={hasBlockingUploadMappingItems(items)}>
          Create dataset
        </Button>
      </ModalFooter>
    </Box>
  );
}
